import { DispoUser } from '../../models/user';

export function getDispoUnapprovedHoursQuery(user: DispoUser): object {
  return {
    $or: [
      {
        invitees: {
          $elemMatch: {
            'customer.id': user.customerId,
            'timeTrackings.toBeApprovedAt': {
              $exists: true,
            },
            'timeTrackings.approvedAt': {
              $exists: false,
            },
          },
        },
      },
      {
        ownerCustomerIds: user.customerId,
        invitees: {
          $elemMatch: {
            'timeTrackings.toBeApprovedAt': {
              $exists: true,
            },
            'timeTrackings.approvedAt': {
              $exists: false,
            },
          },
        },
      },
    ],
  };
}
